<template>
    <div>
        <b-card>
          <h3>Commission Type</h3>
          <br/>
          <b-card>
             <b-form-group label="Select Commision Device Type" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              id="radiogroup"
              v-model="selectedCommission"
              :aria-describedby="ariaDescribedby"
              name="radiogroup"
              >
              <b-form-radio value="C1">Clarence C-1</b-form-radio>
              <b-form-radio value="O1">Clarence O-1</b-form-radio>
              <b-form-radio value="Router">Router</b-form-radio>
              </b-form-radio-group>
          </b-form-group>
          </b-card>
          <b-card>
          <b-row v-if="this.selectedCommission == 'O1' && this.showOptions == true"><b-col>Select Device to Commission:</b-col> 
            <b-col><b-form-select v-model="selectedDevice" :options="commissionOptions" size="sm"></b-form-select></b-col>
          </b-row>
          <b-row v-if="this.selectedCommission == 'C1' && this.showOptions == true"><b-col>Select Device to Commission:</b-col> 
            <b-col><b-form-select v-model="selectedDevice" :options="commissionOptions" size="sm"></b-form-select></b-col>
          </b-row>
          <b-row v-if="this.selectedCommission == 'Router' && this.showOptions == true"><b-col>Select Device to Commission:</b-col> 
            <b-col><b-form-select v-model="selectedDevice" :options="commissionOptions" size="sm"></b-form-select></b-col>
          </b-row>
          </b-card>
          <hr/>
          <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>
        
        </b-card>
    </div>
</template>

<script>
  import axios from "axios";

    export default {
       props:['DataPass','Type','ID','Feeds','Positions'],
      data() {
      return {
        stepComplete: false,
        selectedCommission: "",
        showOptions: false,
        commissionOptions: [],
        selectedDevice: null,
        Values: [],
        ResponseArray: [],
      }
    },
    computed: {},
    components: {},
    watch: {
      selectedCommission() {
      this.LookUpOptions();
    },
    },
    methods:{
      CompletePage(){
        if(this.selectedDevice == null || this.selectedDevice == '' || this.selectedCommission == ''){
          alert('All fields on this page must be completed prior to moving on')
        }else{
          let DeviceEUI = ""
          if (this.selectedCommission == "C1" || this.selectedCommission == "O1"){
            for(let z=0;z<this.ResponseArray.length;z++){
              if(this.selectedDevice == this.ResponseArray[z][1]){
                DeviceEUI = this.ResponseArray[z][0]
              }
            }
          }
        this.Values.push(this.selectedCommission)
        this.Values.push(DeviceEUI)
        this.Values.push(this.selectedDevice) 
        this.$emit("PageComplete",1,this.Values);
        this.stepComplete = true;
        }
      },
      LookUpOptions(){
        this.showOptions = false;
        this.ResponseArray = [];
        this.commissionOptions = [];
        if(this.selectedCommission == 'O1'){
          let LookUpUrl1 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders1 = this.$apikeyPost;
    let LookUpRequest1 = {
      RequestType: "O1DeviceComm",
      Company:
        localStorage.getItem("Company") ||
        localStorage.getItem("ParentCompany"),
    };

    axios
      .post(LookUpUrl1, LookUpRequest1, LookUpHeaders1)
      .then((response) => {
       this.ResponseArray = response.data.Values
       for(let x=0;x<this.ResponseArray.length;x++){
        this.commissionOptions.push(this.ResponseArray[x][1])
       }
      });
          this.showOptions = true;
        } else if (this.selectedCommission =="C1"){
          let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpRequest = {
      RequestType: "NewC1Commission",
      Company:
        localStorage.getItem("Company") ||
        localStorage.getItem("ParentCompany"),
    };

    axios
      .post(LookUpUrl, LookUpRequest, LookUpHeaders)
      .then((response) => {
        this.ResponseArray = response.data.Values

       for(let z=0; z<this.ResponseArray.length; z++){
        this.commissionOptions.push(this.ResponseArray[z][1])
       }
      });
          this.showOptions = true;
        } else if (this.selectedCommission == "Router"){
          let LookUpUrl2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders2 = this.$apikeyPost;
    let LookUpRequest2 = {
      RequestType: "GatewayComm",
      Company:
        localStorage.getItem("Company") ||
        localStorage.getItem("ParentCompany"),
    };

    axios
      .post(LookUpUrl2, LookUpRequest2, LookUpHeaders2)
      .then((response) => {
       let GatewayResponseArray = response.data.Values
       for(let y = 0; y<GatewayResponseArray.length;y++){
        this.commissionOptions.push(GatewayResponseArray[y][0])
       }
      });
          this.showOptions = true;
        }
      }
    },

    }
</script>

<style>

</style>